<template>
  <div class="clientBox">
    <!--의뢰인 정보-->
    <client-infomation/>

    <!--의뢰 내용-->
    <client-content/>


  </div>
</template>

<script>
  import ClientInfomation from "./ClientInfomation";
  import ClientContent from "./ClientContent";

  export default {
    name: "client-box",
    components: {
      ClientContent,
      ClientInfomation

    },
    methods : {

    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";

  .clientBox {
    display: flex;
    flex-direction: row;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/ClientBox.vue